module.exports = __webpack_public_path__ + "static/media/guide_step_1.652d38ed.png";